export const subscribeToSSEApiHandler = {
  method: "GET",
  path: () => `sse`,
  params: {} as {'token'?: string | number}
};